import { SET_SEARCH_CODE } from './types';

const initialState = {
  searchCode: '',
};

export const searchCodeReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SEARCH_CODE:
      return { ...state, searchCode: action.payload };
    default:
      return state;
  }
};
